import axios from '@/plugins/axios';

// 获取机构信息
export function getDepartmentById(departId) {
  return axios.get('/depart/getDepartmentById', {
    params: {
      departId: departId
    }
  });
}

// 获取部门文件列表
export function listDepartFile(departId) {
  return axios.get('/depart/listDepartFile', {
    params: {
      departId: departId
    }
  });
}
// 查询供应商信息详情
export function getOrgSupplierInfo(supplierOrgId) {
  return axios.get('/userSupplier/getOrgSupplierInfo', {
    params: {
      supplierOrgId: supplierOrgId
    }
  });
}
// 查询采购方信息详情
export function getOrgBuyerInfo(buyerOrgId) {
  return axios.get('/userSupplier/getOrgBuyerInfo', {
    params: {
      buyerOrgId: buyerOrgId
    }
  });
}

// 查询管理员所在的部门
export function loadDepartment(departId) {
  return axios.get('/depart/loadDepartment', {
    params: {
      departId: departId
    }
  });
}
// 查询每个部门下的用户数量
export function loadDepartmentUserCount(departId) {
  return axios.get('/depart/loadDepartmentUserCount', {
    params: {
      departId: departId
    }
  });
}
// 新增部门
export function saveDepartment(params) {
  return axios.post('/depart/saveDepartment', params);
}
// 修改部门
export function updateDepartment(params) {
  return axios.post('/depart/updateDepartment', params);
}
// 删除部门
export function deleteDepartmentById(departId) {
  return axios.post('/depart/deleteDepartmentById', { departId: departId });
}
// 申请实名认证
export function applyRealName(params) {
  return axios.post('/departRealName/saveDepartRealName', params);
}

// 更新实名信息
export function cancelRealName() {
  return axios.post('/departRealName/cancelDepartRealName', {});
}
// 删除资质信息
export function deleteDepartFile(params) {
  return axios.post('/depart/deleteDepartFile', params);
}
// 上传资质文件
export function uploadFile(params) {
  return axios.post('/depart/uploadFile', params);
}

export function editDepartFile(params) {
  return axios.post('/depart/editDepartFile', params);
}

export function deleteBusi(params) {
  return axios.post('/depart/uploadBusi', params);
}

// 管理员机构账户列表
export function listDepart(params) {
  return axios.post('/depart/listDepart', params);
}

// 添加机构及管理员
export function saveAllInfo(params) {
  return axios.post('/depart/saveAllInfo', params);
}

// 修改机构及管理员
export function updateAllInfo(params) {
  return axios.post('/depart/updateAllInfo', params);
}

export const DEPART_USER_INFO = {
  departType: [
    { id: '1', text: '供应商' },
    { id: '2', text: '采购商' },
    { id: '3', text: '全部' }
  ],
  departStatus: [
    { id: '0', text: '首次注册' },
    { id: '1', text: '正常登录' },
    { id: '2', text: '停止登录' }
  ],
  multiRoles: [
    { id: '0', text: '否' },
    { id: '1', text: '是' }
  ]
};

// 删除机构及管理员
export function deleteDepartList(params) {
  return axios.post('/depart/deleteDepartList', params);
}

export function updateStatus(params) {
  return axios.post('/depart/updateStauts', params);
}

// 实名破解验证码获取信息
export function getVerifyCode(code) {
  return axios.get('/depart/getVerifyCode', {
    params: {
      code: code
    },
    timeout: 30000
  });
}
